export default __webpack_public_path__ + "static/media/mask.0a54979e.jpg";